import React from 'react';
import  { useEffect, useState } from 'react';
import numeral from 'numeral';
import { Grid, Typography, Link, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { isBoolean, isEmpty } from 'lodash/lang';
import NoticeBox from 'components/NoticeBox';
import Dialog from 'components/CustomDialog';

import CustomDialog from 'components/Dialog';

import InfoRow from 'components/InfoRow';

import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import { api } from 'environments';
import messages from 'containers/ApplicationFormPage/messages';
import { FormattedMessage } from 'react-intl';
const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: '660px',
  },
  link: {
    //color: '#00C3B4',
    'text-decoration': 'underline',
  },
  disabled: {
    color: '#B6B8B4',
  },
  primary: {
    color: theme.palette.primary.dark,
  },
  timelinedot: {
    width: 15,
    height: 15
  }
}));

const pmc_link = 'https://mobileapp.primehealth.ae:5040/preinsuweb/Prime_PreInsuranceAppointment'

export default function Section(props) {
  const classes = useStyles();
  const { parties } = props;

  

  const [dialogUW, setDialogUW] = useState(false);
  const nameList = parties
        .filter(item => !isEmpty(item.underwriting.enhancedMedicalParam))
        .map(item => item.firstName + " " + item.lastName);
  const nameListNonMedical = parties
        .filter(item => isEmpty(item.underwriting.enhancedMedicalParam))
        .map(item => item.firstName + " " + item.lastName);

  function getInsuredNameWithInterviewRequired() {
    if(nameList.length > 1){
      return <><b>{nameList[0]}</b> and <b>{nameList[1]}</b> </>
    } else {
      return <b>{nameList[0]}</b>
    }
  }

  
  return (
    <>
      <Grid item>
        <Typography variant="body1" color="primary">

          <Timeline align="left">
            <TimelineItem >
              <TimelineOppositeContent style={{flex: 0, display: 'none' }} />
              <TimelineSeparator ><TimelineDot style={{backgroundColor: "#EA635C"}} className={classes.timelinedot}/><TimelineConnector style={{backgroundColor: "#EA635C"}}/></TimelineSeparator>
              <TimelineContent>
                <Typography>
                  {getInsuredNameWithInterviewRequired()} {nameList && (nameList.length > 1? " are " : " is ")} <FormattedMessage {...messages.teleInterviewEligibleMsg}/>        
                </Typography>
                <Typography>
                  <b><FormattedMessage {...messages.teleInterMsg1}/> </b>
                </Typography>
                { nameListNonMedical && (nameListNonMedical.length > 0 ? 
                  <Typography style={{marginTop:'10px'}}>
                      For <b>{nameListNonMedical[0]}</b>, <FormattedMessage {...messages.uwAcceptedMedicalMsg}/>
                  </Typography>:<></>
                )}
              </TimelineContent>
            </TimelineItem>
            <TimelineItem>
              <TimelineOppositeContent style={{flex: 0, display: 'none' }} />
              <TimelineSeparator><TimelineDot style={{ backgroundColor: "#EA635C" }} className={classes.timelinedot}/> <TimelineConnector style={{backgroundColor: "#EA635C"}}/></TimelineSeparator>
              <TimelineContent>
                <Typography><b><FormattedMessage {...messages.nextSteps} /> </b></Typography>
                <ol style={{marginTop:'10px'}}>
                  <li>
                    <FormattedMessage {...messages.teleInterSubmitApplicationMsg} /> {getInsuredNameWithInterviewRequired()}.
                  </li>
                  <li><Link
                    href="#"
                    onClick={e => {
                      e.preventDefault();
                      setDialogUW(true);}}
                    color="inherit"
                    variant="body3"
                    //underline="none"
                    className={classes.link}
                  >
                   <b>Book an appointment</b>
                </Link> today with Prime Homecare.</li>
                  <li>Once you book the appointment, Prime Homecare will call the customer to carry out the tele-interview.</li>
                  
                </ol>   
              </TimelineContent>
            </TimelineItem>
            <TimelineItem>
              <TimelineOppositeContent style={{flex: 0, display: 'none' }} />
              <TimelineSeparator ><TimelineDot style={{backgroundColor: "#4066B3"}} className={classes.timelinedot}/></TimelineSeparator>
              <TimelineContent>
                <Typography><b>Inform your customer</b></Typography>
                <ol style={{marginTop:'10px'}}>
                  <li>The call usually takes about 30 minutes.</li>
                  <li>They should have their ID ready for verification.</li>
                  <li>Let them know when to expect this call, so they’re prepared.</li>
                </ol>
              </TimelineContent>
            </TimelineItem>
          </Timeline>
      
          <NoticeBox variant="withoutIcon">
              <p><b>Good to know:</b></p>
              <p>If your customer has already completed <b>Zurich medicals in the past 12 months</b>, this step won’t be needed. After underwriting review, we may request more information if needed. </p>
          </NoticeBox>
          
        </Typography>
      </Grid>
      <Dialog
        open={dialogUW}
        onClose={() => {
          setDialogUW(false);
        }}
        variant="info"
        //title="Send"
        actions={
          <Grid
            container
            alignItems="center"
            wrap="nowrap"
            justify="center"
            spacing={2}
          >

            <Grid item>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={() => {
                   window.open(api.pmc_link, "_blank", "noreferrer");
               }}
              >
                Continue
              </Button>
            </Grid>
          </Grid>
        }
      >
        <Typography variant="body1" style={{ fontWeight: 500 }}>
          You'll be redirected to <b><u style={{ fontWeight: 900 }}>Prime Homecare's Website.</u></b> They'll handle your personal data in line with their Data Protection and Privacy policy.
        </Typography>
        <br />
        
      </Dialog>

      
    </>
  );
}
